import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { enums, fetchState } from './redux/reducers';
import {
  setOnbehalf,
  getAll,
  getOnbehalf,
  getADA,
} from '../../utils/loginSession';
import { toastMsg } from '../toastMessage/toastMessage';
import PopupConfirm from '../popupConfirm/popupConfirm';
import { DeleteIcon } from './icon/Delete';
import { DropIcon } from './icon/Drop';
import { ContentsIcon } from './icon/Contents';
import { PackUpIcon } from './icon/PackUp';
import { CheckIcon } from './icon/check';
import { CheckedIcon } from './icon/checked';
import CheckboxIcon from './icon/Checkbox.png';
import CheckedboxIcon from './icon/Checkedbox.png';
import useBreakpoint from "../../hooks/useBreakpoint";

import { getCSFrontendMsg } from '../../utils/utility';
import { frontEndMessageCodes } from '../../utils/Constants/Constants';
import styles from './switchrecipient.scss';
import axios from "../../utils/axios_interceptor"
import { getAccessHeader } from '../../utils/loginSession';
import { getAcApiUrl, getRouter } from '../../utils/helper';
import PropTypes from 'prop-types';
import Loader from '../PageLoader';

/**
 * *Comments of the parameters
 *
 * @param {String} pVariant 'buyer' / 'pickup' / 'recipient'.
 * @param {Boolean} showPopup Change the value to refresh the regular purchaser.
 * @param {Function} callBackClose Function to close the switch recipient component.
 * @param {String} breakpoint 'xs' / 'sm' / 'md' / 'lg' / 'xl' (Screen Size)
 * @param {Object} router getRouter() [import { getRouter } from '@tw/shared-ui-components/lib/utils/helper';]
 * @param {Boolean} parentOnClose This is a function that will clear all the input and refresh to latest data, pass true to perform action.
 * @param {String} preSelectedAda Selected abo number.
 *
 */

function SwitchRecipient({
  pVariant,
  showPopup,
  callBackClose,
  parentOnClose,
  preSelectedAda,
}) {
  const breakpoint = useBreakpoint();
  const styleView = breakpoint !== 'xs' && breakpoint !== 'sm' ? styles.pcView : styles.mobileView;
  const isDesktop = breakpoint !== 'xs' && breakpoint !== 'sm';
  const getState = useSelector(state => state);
  const history = getRouter();
  // 獲取登錄者本人信息
  const login = getAll(getState);

  const dispatch = useDispatch();
  const addRef = useRef();
  const textInputRef = useRef(null);
  const scrollRef = useRef(null);
  // 獲取常用聯繫人列表

  const userName = login.mainName;
  const userAda = login.ada;
  const userRole = login.role;
  const userType = login.loginType;
  const userMemberType = login.loginMemberType;

  //獲取更新常用聯繫人
  const [purchaser, setPurchaser] = useState([]);
  const [topContacts, setTopContacts] = useState(false);
  const [checkBox, setCheckBox] = useState(true);
  const [delABO, setDelABO] = useState('');
  const [showPopupDel, setShowPopupDel] = useState(false);
  const [iptPurchaserABO, setIptPurchaserABO] = useState("");
  //定義提示信息
  const [tips_ipt, setTipsIpt] = useState({ status: false });
  //輸入安利賬號時獲取焦點
  const [selectedContainer, setSelectedContainer] = useState(
    preSelectedAda ? preSelectedAda : getOnbehalf().ada
  );
  const [selectedRecipient, setRecipient] = useState(getOnbehalf());
  const purchaserIsLoading = useSelector(
    state => state?.recipientState?.regularPurchaser?.isloading
  );
  const callbackData = useSelector((state) => state?.recipientState?.callback);
  useEffect(() => {
    fetchRegularPurchasers();
  }, [showPopup]);

  useEffect(() => {
    if (!parentOnClose) return;
    setIptPurchaserABO("");
    if (pVariant === 'buyer') setSelectedContainer(getOnbehalf().ada);
    setTipsIpt({ status: false });
    callBackClose();
  }, [parentOnClose]);

  useEffect(() => {
    if (!showPopupDel || !showRenew.status) {
      document.body.style.overflowY = "hidden";
    }
  }, [showPopupDel, showRenew]);

  const fetchRegularPurchasers = async () => {
    if (userAda !== null && userAda !== "") {
      let res = await dispatch(fetchState(enums.SET_REGULARPURCHASERS_STATE, { loginAda: userAda }));
      if (res?.data) {
        setPurchaser(res.data.regularPurchaserResList);
      } else {
        setPurchaser([]);
      }

      let isManualContainer = true;

      if (userAda === selectedContainer) isManualContainer = false;
      if (res?.data && res?.data.regularPurchaserResList)
        res.data.regularPurchaserResList.forEach(regularPurchaser => {
          if (regularPurchaser.purchaserABO === selectedContainer) isManualContainer = false;
        });

      if (isManualContainer) {
        setIptPurchaserABO(getOnbehalf()?.ada?.trim());
        setSelectedContainer('manual');
      }
    }
  };

  const handleOnClose = (data, type) => {
    setIptPurchaserABO("");
    if (pVariant === 'buyer') setSelectedContainer(getOnbehalf().ada);
    setTipsIpt({ status: false });
    if (type) {
      return
    }
    callBackClose(data);
  };

  //切換常用聯繫人
  const switchUser = item => {
    if (item != undefined) {
      const onbehalf = {
        ada: item.purchaserABO,
        role: userRole,
        name: item.purchaserName1,
        loginType: item.businessNature1,
        loginMemberType: item.businessNature3,
      };
      setRecipient(onbehalf);
    }
  };

  // 切換到本人
  const switchSelf = () => {
    const onbehalf = {
      ada: userAda,
      role: userRole,
      name: userName,
      loginType: userType,
      loginMemberType: userMemberType,
    };
    setRecipient(onbehalf);
  };

  //下拉顯示常用聯繫人
  const changeUser = () => {
    setTopContacts(!topContacts);
  };

  //設置常用聯繫人
  const handleChange = () => {
    setCheckBox(!checkBox);
  };

  //刪除按鈕彈框
  const handleActionDelBtn = purchaserABO => {
    setDelABO(purchaserABO);
    setShowPopupDel(true);
  };

  //刪除聯繫人取消按鈕
  const handleActionDelCancel = () => {
    setShowPopupDel(false);
  };

  //刪除聯繫人確認按鈕
  const handleActionDel = async () => {
    //派發刪除請求
    let res = await dispatch(
      fetchState(enums.SET_DELETE_REGULARPURCHASER_STATE, {
        loginAda: login.ada,
        purchaserABO: delABO,
      })
    );
    if (res?.success && res?.code == "0") {
      fetchRegularPurchasers();
      setShowPopupDel(false);
      let successMsg = await getCSFrontendMsg(frontEndMessageCodes.SR_SUCCESS_DELETE);
      toastMsg(successMsg.message, '', successMsg.messageType);
    } else {
      toastMsg(res.message, 'error');
    }
  };

  //獲取輸入的purchaserABO編號
  const handleChangeIpt = e => {
    setTipsIpt(false);
    let adaNun = e.target.value;
    setIptPurchaserABO(adaNun?.trim());

    if (userAda === e.target.value) {
      //User key in self Abo Number
      inputOnFocus(userAda);
    } else if (purchaser && purchaser.length > 0) {
      purchaser.forEach(regularPurchaser => {
        if (regularPurchaser.purchaserABO === e.target.value) {
          if (textInputRef.current) {
            textInputRef.current.blur(); // 让输入框失去焦点
          }
          onScrollContainer(e.target.value)
          //Abo Number already in the purchaser list
          inputOnFocus(regularPurchaser.purchaserABO, regularPurchaser);
          setIptPurchaserABO("");
        }
      });
    }
  };

  const onScrollContainer = anchorName => {
    if (scrollRef.current && typeof window !== undefined && typeof window !== 'undefined') {
      // 找到锚点
      let anchorElement = document.getElementById(anchorName);
      // 如果对应id的锚点存在，就跳转到锚点
      if (scrollRef.current) {
        const targetTop = anchorElement.offsetTop;
        const containerHeight = scrollRef.current.clientHeight;
        const targetHeight = anchorElement.clientHeight;
        const scrollPosition = Math.min(targetTop, containerHeight - targetHeight);
        setTimeout(() => {
          // scrollRef.current.scrollTop = scrollPosition;
          scrollRef.current.scrollTo({
            top: scrollPosition,
            behavior: 'smooth',
          });
        }, 500);
      }
    }
  }
  //點擊頁面底部的確定按鈕
  const confirmUserSwitch = async () => {
    if (selectedContainer === 'manual') {
      if (!iptPurchaserABO) {
        setTipsIpt({ status: true, message: '請輸入訂貨人編號或選擇您的常用訂貨人' });
        return;
      } else {

        const validateUserParams = {
          loginAda: login.ada,
          purchaserABO: iptPurchaserABO,
        }

        // 切換收貨人  新增用戶  不攔截黑名單用戶
        if (pVariant !== 'buyer') {
          validateUserParams['noBlackValidate'] = true;
        }

        //派發驗證聯繫人請求
        let validatePuchaserResuest = await dispatch(
          fetchState(enums.SET_VALIDATE_PURCHASER_STATE, validateUserParams)
        );

        // AboNumber Invalid
        if (validatePuchaserResuest.message !== 'success') {
          //顯示紅色的提示信息
          if (validatePuchaserResuest.code === 'UC.B.NOT_IN_A_SAME_DD_GROUP.01') {
            setTipsIpt({ status: true, message: '此編號非同一白金小組，請重新輸入' });

          } else if (validatePuchaserResuest.code === 'UC.B.LOGIN_ABO_IN_BLACKLIST.01' || validatePuchaserResuest.code === 'UC.B.PURCHASE_ABO_IN_BLACKLIST.01') {
            // setTipsIpt({ status: true, message: pVariant == 'buyer' ? '目前無法切換訂貨人，請聯繫客服協助' : '目前無法切換，請聯繫客服協助' });
            if (pVariant == 'buyer') {
              setTipsIpt({ status: true, message: '目前無法切換訂貨人，請聯繫客服協助' });
            }
          } else {
            setTipsIpt({ status: true, message: '您輸入的編號有誤，請重新輸入' });

          }
        }

        // Add to Frequent Purchasers
        if (checkBox) {
          let addFrequentContactRequest = await dispatch(
            fetchState(enums.SET_ADD_FREQUENTCONTACTS_STATE, validateUserParams)
          );
          if (addFrequentContactRequest.message !== 'success') {
            if (addFrequentContactRequest.code === 'UC.B.LOGIN_ABO_IN_BLACKLIST.01' || addFrequentContactRequest.code === 'UC.B.PURCHASE_ABO_IN_BLACKLIST.01') {
              if (pVariant == 'buyer') {
                toastMsg(addFrequentContactRequest.message, 'error');
                return;
              }
            } else {
              toastMsg(addFrequentContactRequest.message, 'error');
              return;
            }
          }

          //Refresh Frequent Purchasers
          await fetchRegularPurchasers();
        }

        switch (pVariant) {
          case 'buyer':
            //派發查詢輸入的安利編號對應的name請求
            let res = await dispatch(
              fetchState(enums.SET_IPTNAME_STATE, { aboNumber: iptPurchaserABO, loginAda: login.ada })
            );
            if (
              res &&
              res.data[0] &&
              res.data[0].details[0] &&
              res.data[0].details[0].basic &&
              res.data[0].details[0].applicant
            ) {
              //通過存儲在cookies攜帶數據
              const recipient = {
                ada: iptPurchaserABO,
                role: res.data[0].details[0].basic.businessNature3,
                name: res.data[0].details[0].applicant.localName1,
                loginType: res.data[0].details[0].basic.businessNature1,
                loginMemberType: res.data[0].details[0].basic.businessNature3,
              };

              switchOnBehalf(recipient, purchaser);
            }
            break;
          case 'pickup':
            await dispatch(
              fetchState(enums.SET_PICKUP_STATE, {
                aboNumber: iptPurchaserABO,
                loginAda: userAda,
              })
            ).then((res) => {
              if (res && res?.code == "0") {
                handleOnClose(res?.data);
              } else {
                handleOnClose();
              }
            })
            break;
          case 'recipient':
            callbackRecipient(iptPurchaserABO);
            break;
          default:
        }
      }

    } else {
      switch (pVariant) {
        case 'buyer': // 切换订货人
          if (selectedRecipient?.ada === getOnbehalf().ada) {
            handleOnClose();
            return;
          }
          //選中聯繫人之後點擊確定按鈕跳轉頁面
          switchOnBehalf(selectedRecipient, purchaser);
          break;
        case 'pickup': // 取货
          const setPickupState = async () => {
            await dispatch(
              fetchState(enums.SET_PICKUP_STATE, {
                aboNumber: selectedRecipient?.ada,
                loginAda: userAda,
              })
            ).then((res) => {
              if (res && res?.code == "0") {
                handleOnClose(res?.data);
              } else {
                handleOnClose();
              }
            })
          }
          switchOnBehalf(selectedRecipient, purchaser, setPickupState);
          break;
        case 'recipient': // 宅配
          switchOnBehalf(selectedRecipient, purchaser, callbackRecipient);
          // callbackRecipient(selectedRecipient?.ada);
          break;
        default:
      }
    }
  };

  const switchOnBehalf = async (recipient, purchaser = [], callback) => {
    //Clear Address
    // setRecipientAddress("");

    //Set Consignee info into Local Storage **ONLY set for BUYER**

    let aboNumber = recipient.ada;

    const profileRequest = await axios.post(
      getAcApiUrl() + '/profile',
      {
        aboNumber: aboNumber,
        loginAda: getADA(),
        loginInfo: true,
      },
      {
        headers: getAccessHeader(getState),
      }
    );

    if (!profileRequest.data || !profileRequest.data.expiredNotification) {
      toastMsg(profileRequest.data.message, 'error');
      return;
    }

    let userList = purchaser.map(user => {
      if (user.purchaserABO === aboNumber) {
        user.isExpired = profileRequest.data.expiredNotification.isExpired;

        if (profileRequest.data.expiredNotification.isExpired && selectedContainer !== ' manual') {
          switch (profileRequest.data.expiredNotification.option) {
            case 4:
              user.expiredMsg = '此訂貨人編號已到期，請先續約再進行切換訂貨人';
              // toastMsg('此訂貨人編號已到期，請先續約再進行切換訂貨人', 'error')
              break;
            case 5:
              user.expiredMsg = '此訂貨人編號已過期，請更換其他訂貨人編號';
              // toastMsg('此訂貨人編號已過期，請更換其他訂貨人編號', 'error')
              break;
            case 6:
              const errorData = profileRequest.data.errorData;
              if (errorData && pVariant !== 'buyer') {
                const { code } = errorData;
                if (code !== 'UC.B.PURCHASE_ABO_IN_BLACKLIST.01' && code !== 'UC.B.LOGIN_ABO_IN_BLACKLIST.01') {
                  // user.expiredMsg = message;
                  user.expiredMsg = '目前無法切換，請聯繫客服協助';
                }
              } else {
                user.expiredMsg = pVariant == 'buyer' ? '目前無法切換訂貨人，請聯繫客服協助' : '目前無法切換，請聯繫客服協助';
              }
              // toastMsg('目前無法切換訂貨人，請聯繫客服協助', 'error')
              break;
            default:
          }
        }
      }
      return user;
    });

    let showRenewStatus = { status: false };

    switch (profileRequest.data.expiredNotification.option) {
      case 0: // No Expire
        localStorage.removeItem('memberExpNotification');
        showRenewStatus = { status: false };
        break;

      case 1: // 2 months to expire
        const today = new Date();
        const lastNotification = new Date(
          localStorage.getItem('memberExpNotification') || '1900-01-01'
        );
        const notiDiffTime = Math.abs(lastNotification - today);
        const notiDiffDays = Math.ceil(notiDiffTime / (1000 * 3600 * 24));
        if (userList.length > 0) setPurchaser([...userList]);

        if (notiDiffDays > 7) {
          localStorage.setItem('memberExpNotification', today.toISOString());
          showRenewStatus = { status: true, name: recipient.name };
        }
        break;

      case 3: // 1 days to expire
        if (userList.length > 0) setPurchaser([...userList]);
        showRenewStatus = { status: true, name: recipient.name };
        break;

      case 4: //expired within 3 months
      case 5: //expired after 3 months
      case 6:
        if (userList.length > 0) setPurchaser([...userList]);
        localStorage.removeItem('memberExpNotification');
        showRenewStatus = { status: false };
        const errorData = profileRequest.data.errorData;
        const { code } = errorData;
        if (pVariant !== 'buyer') {
          // 不攔截
          if (code === 'UC.B.PURCHASE_ABO_IN_BLACKLIST.01' || code === 'UC.B.LOGIN_ABO_IN_BLACKLIST.01') {
            callback && callback(aboNumber);
          }
        }
      default:
    }

    if (!profileRequest.data.expiredNotification.isExpired && callback) {
      callback(aboNumber);
      return;
    }

    if (!profileRequest.data.expiredNotification.isExpired) {
      setOnbehalf(recipient);
      let successMsg = await getCSFrontendMsg(frontEndMessageCodes.SR_SUCCESS_SWITCH);
      toastMsg(successMsg.message, '', successMsg.messageType);
    }


    if (profileRequest?.data?.expiredNotification?.validateResult) {
      const { applicant, expireDate, expiredNotification } = profileRequest?.data
      setShowRenew({ status: true, validateResult: expiredNotification?.validateResult, name: applicant?.localName1, date: expiredNotification?.date });
      handleOnClose({}, true);
      return false
    }

    if (!showRenewStatus.status && !profileRequest.data.expiredNotification.isExpired)
      handleOnClose();



  };

  const callbackRecipient = async ada => {
    // setRecipientAddress("");

    let res = await dispatch(
      fetchState(enums.SET_RECIPIENT_STATE, { aboNumber: ada, loginAda: getADA() })
    );

    if (res && res.data && res.data.addressItems) {
      const addresses = res.data.addressItems;
      let addressDefault = res.data.addressItems.filter(item => item.addressNumber === 1)[0];
      if (addressDefault == undefined) {
        addressDefault = addresses.length > 0 ? addresses[0] : {};
      }

      //Set Address to local storage for later access
      // setRecipientAddress(addressDefault);
    }
    handleOnClose();
  };

  const inputOnFocus = (code, item) => {
    setSelectedContainer(code);
    switch (code) {
      case 'manual':
        break;
      case userAda:
        switchSelf();
        break;
      default:
        switchUser(item);
        break;
    }
  };

  const [showRenew, setShowRenew] = useState({ status: false, name: '', date: '' });

  const handleRenewClose = () => {
    let close = !showRenew.isExpired;
    setShowRenew({ status: false });
    if (close) handleOnClose();
  };

  const handleRenewOK = () => {
    setShowRenew({ status: false });
    handleOnClose();
    history.push('/profile/memberrenew');
  };
  const handleScroll = (event) => {
    event.stopPropagation();
  };
  return (
    <>

      <div className={`${isDesktop ?
        pVariant == 'recipient' ? styles.scrollTopContainerRecipientPC : styles.scrollTopContainerPC :
        pVariant == 'recipient' ? styles.scrollTopContainerRecipientMobile : styles.scrollTopContainerMobile
        }`} ref={scrollRef} id="scrollRef" onScroll={handleScroll}>
        <div className={`${styles.newContactContainer} ${styleView}`}>
          {/* <span style={{ visibility: 'hidden' }}>訂貨人編號</span> */}
          <div
            className={`${styles.amway_num}  ${selectedContainer !== 'manual' ? '' : styles.focus_ipt
              }`}
            onClick={() => inputOnFocus('manual')}
          >
            <div className={styles.left}>
              {selectedContainer === 'manual' ? <CheckedIcon /> : <CheckIcon />}
            </div>
            <div className={styles.right}>
              <input
                className={`${tips_ipt.status ? styles.tips_ipt : styles.search_num}  ${selectedContainer !== 'manual' ? styles.blur_ipt : styles.focus_ipt
                  }`}
                type="text"
                name="contact"
                placeholder="請輸入直銷商/會員編號"
                value={iptPurchaserABO}
                onChange={e => handleChangeIpt(e)}
                ref={textInputRef}
              />
              {tips_ipt.status ? <div className={styles.error}>{tips_ipt.message}</div> : ''}
              <div className={styles.save_contacts}>
                <img src={checkBox ? CheckedboxIcon : CheckboxIcon} onClick={() => handleChange()} />
                <span>保存</span>
              </div>
            </div>
          </div>
        </div>

        <div className={`${styles.frequentContactsContainer} ${styleView}`}>
          <span onClick={changeUser}>
            我的常用編號
            <span>{topContacts ? <DropIcon /> : <PackUpIcon />}</span>
          </span>
          <Loader LoadingState={purchaserIsLoading}>
            <ul
              className={`${styles.frequent_contacts} ${purchaser && purchaser.length !== 0 ? '' : styles.noFrequentContacts
                }  ${!topContacts ? '' : styles.no_user}`}
            >
              {purchaser && purchaser.length !== 0 ? (
                purchaser.map((item, index) => {
                  return (
                    <div
                      key={`purchaser${index}`}
                      className={`${styles.information}  ${selectedContainer === item.purchaserABO ? styles.check_top : ''
                        } ${item.isExpired ? styles.expired : ''}`}
                      id={item?.purchaserABO}
                    >
                      <div>
                        <div
                          className={styles.information2}
                          key={index}
                          onClick={() => inputOnFocus(item.purchaserABO, item)}
                        >
                          {selectedContainer === item.purchaserABO ? <CheckedIcon /> : <CheckIcon />}
                          <span>{item.purchaserName1.trim()}</span>
                          <div className={styles.point}>•</div>
                          <em>{item.purchaserABO}</em>
                        </div>
                        <div
                          className={styles.icon_del}
                          onClick={() => handleActionDelBtn(item.purchaserABO)}
                        >
                          <DeleteIcon />
                        </div>
                      </div>
                      {item.isExpired && <div className={styles.error}>{item.expiredMsg}</div>}
                    </div>
                  );
                })
              ) : (
                <ContentsIcon />
              )}
            </ul>
          </Loader>
        </div>

        <div className={`${styles.header} ${styleView}`}>
          <div
            className={`${styles.user_self}   ${selectedContainer === userAda ? styles.check_top : ''
              } `}
            onClick={() => inputOnFocus(userAda)}
          >
            {selectedContainer === userAda ? <CheckedIcon /> : <CheckIcon />}
            <span>切換回本人訂貨帳號</span>
            <div>•</div>
            <em>{userAda}</em>
          </div>
        </div>

      </div>

      <div className={`${styles.bottom_btn}  ${styleView}`}>
        <div className={styles.check_btn} onClick={confirmUserSwitch}>
          確認
        </div>
      </div>

      {showPopupDel &&
        <PopupConfirm
          title="確認刪除此訂貨人？"
          showPopup={showPopupDel}
          okBtn={{
            text: '刪除',
            action: handleActionDel,
          }}
          cancelBtn={{
            text: '保留',
            action: handleActionDelCancel,
          }}
        >
          <span>一旦刪除後就無法復原，請確認刪除與否</span>
        </PopupConfirm>
      }

      {showRenew?.status &&
        <PopupConfirm
          title="續約"
          showPopup={showRenew.status}
          autoDisable={false}
          okBtn={{
            text: '立即續約',
            action: handleRenewOK,
          }}
          cancelBtn={{
            text: '取消',
            action: handleRenewClose,
          }}
        >
          {
            showRenew?.validateResult ?
              <>
                <p style={{ textAlign: 'center', lineHeight: '22px' }}>{`親愛的${showRenew.name?.trim()}夥伴您好，`}</p>
                <p style={{ textAlign: 'center', lineHeight: '22px', padding: '0 20px' }}>{`您的會員到期日 為${showRenew.date}，恭喜您符合首年續約方案，立即續約即享等價優惠券。`}</p>
              </>
              :
              <>
                <span>{`${showRenew.name}已可辦理續約，如須隨貨續約，請點選以下續約按鈕，選擇欲續約之選項加入購物車進行結賬。`}</span>
              </>
          }

        </PopupConfirm>
      }


    </>
  );
}

export default SwitchRecipient;

SwitchRecipient.defaultProps = {
  pVariant: '',
  showPopup: false,
  callBackClose: () => { },
  breakpoint: '',
  router: {},
  parentOnClose: false,
  preSelectedAda: '',
};

// PropsTypes of upcoming parameters
SwitchRecipient.propTypes = {
  pVariant: PropTypes.string,
  showPopup: PropTypes.bool,
  callBackClose: PropTypes.func,
  breakpoint: PropTypes.string,
  router: PropTypes.object,
  parentOnClose: PropTypes.bool,
  preSelectedAda: PropTypes.string,
};
